<template>
  <div class="subject">
    <div class="topTitle">
      <div v-if="$route.query.edt === 'edt'">
        <el-page-header @back="goback" content="编辑比赛题目">
        </el-page-header>
        <!-- <span style="cursor: pointer;" @click="goback">返回</span> / 编辑比赛题目 -->
      </div>
      <div v-else>
        <el-page-header @back="goback" content="新增比赛题目">
        </el-page-header>
        <!-- <span style="cursor: pointer;" @click="goback">返回</span> <span> / 新增比赛题目 </span> -->
      </div>

    </div>
    <div class="table">
      <!-- <div style="overflow: hidden;">
        <div class="fl">问题列表</div>
      </div>
      <el-divider></el-divider> -->

      <el-form ref="problem" :model="problem" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="title" label="题目名称" required>
              <el-input size="small" style="width: calc(100% - 100px)" placeholder="题目名称" v-model="problem.title" maxlength="200" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="可选编程语言" required>
              <el-checkbox-group v-model="problem.languages" @change="languagesChange">
                <el-checkbox v-for="item in languagess" :label="item.id" :key="item.id">{{ item.name }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="10">
            <el-form-item label="显示分数" required>
              <el-radio v-model="problem.rule_type" :label="1"> ACM (不显示分数)</el-radio>
              <el-radio v-model="problem.rule_type" :label="2"> OI (显示分数)</el-radio>
            </el-form-item>
          </el-col> -->

        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否公开" v-if="isShow3" required>
              <el-radio v-model="problem.is_public" label="0">私有</el-radio>
              <el-radio v-model="problem.is_public" label="1" style="margin-right: 3px;">公开</el-radio>
              <el-tooltip class="item" effect="dark" content="公开后,题目将会显示到题库中" placement="top-start">
                <span class="el-icon-question"></span>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form ref="problem" :model="problem" :rules="rules" label-position="top" label-width="70px">
        <el-row :gutter="20" v-if="isShowMarkDown">
          <el-col :span="24">
            <el-form-item prop="" label="问题描述">
              <markdownShow v-if="showmarkdown" @changeMardown="changeMardown" :markdown="problem.markdown_explain" @SaveMarkDown="SaveMarkDown">
              </markdownShow>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="" label="输入描述">
              <markdownShow v-if="showmarkdown1" @changeMardown="changeMardown1" :markdown="problem.md_input_description" @SaveMarkDown="SaveMarkDown1">
              </markdownShow>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="" label="输出描述">
              <markdownShow v-if="showmarkdown2" @changeMardown="changeMardown2" :markdown="problem.md_output_description" @SaveMarkDown="SaveMarkDown2">
              </markdownShow>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="" label="提示">
              <markdownShow v-if="showmarkdown3" @changeMardown="changeMardown3" :markdown="problem.md_hint" @SaveMarkDown="SaveMarkDown3">
              </markdownShow>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item prop="" label="附件">
              <el-upload action="" :http-request="uploadFile1" :on-remove="handleRemove1" :on-change="handleChangeFile1" :auto-upload="false" :limit="1" :file-list="problem.fileList1" style="width: 400px">
                <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i></el-button>
              </el-upload>
            </el-form-item>

          </el-col>
        </el-row>
        <div>
          <el-form-item v-for="(item, index) in problem.samples" :key="index">
            <el-card>
              <div slot="header" class="clearfix">
                <span>{{ 'samples' + (index + 1) }}</span>
                <el-button type="warning" size="small" style="float: right" icon="el-icon-delete" slot="header" @click="deleteSample(index)">
                  Delete
                </el-button>
              </div>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="输入样式" required>
                    <el-input :rows="5" type="textarea" placeholder="输入样式" v-model="item.input">
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="输出样式" required>
                    <el-input :rows="5" type="textarea" placeholder="输出样式" v-model="item.output">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
          </el-form-item>
        </div>
        <div class="add-sample-btn">
          <button type="button" class="add-samples" @click="addSample"><i class="el-icon-plus"></i>添加样式
          </button>
        </div>
        <el-form-item label="Special Judge">
          <el-col :span="24">
            <el-checkbox v-model="problem.spj" @change="spjBtn">Special Judge</el-checkbox>
            <!-- <el-radio v-model="problem.spj" @change="spjBtn" label="0">Special Judge</el-radio> -->

          </el-col>
        </el-form-item>
        <el-form-item>
          <el-card title="Special Judge" v-if="isShow">
            <template slot="header">
              <span>Special Judge</span>
              <div class="fr">
                <el-radio-group v-model="problem.spj_language">
                  <el-tooltip class="spj-radio" v-for="lang in allLanguage" :key="lang.name" effect="dark" :content="lang.name" placement="top-start">
                    <el-radio :label="lang.id">{{ lang.name }}</el-radio>
                  </el-tooltip>
                </el-radio-group>
                <el-button style="margin-left:20px" type="primary" @click="compileSpj" size="small" icon="el-icon-fa-random" :loading="loadingCompile">
                  编译
                </el-button>
              </div>
            </template>
            <code-mirror v-model="problem.spj_code" :mode="spjMode"></code-mirror>
          </el-card>
        </el-form-item>
        <el-row :gutter="20" v-if="problem.rule_type === 2 ? false : true">
          <el-col :span="8">

            <el-form-item label="分值" required prop="total_score">
              <el-input placeholder="分值" v-model="problem.total_score"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row style="margin-bottom:50px">
          <el-form-item label="测试用例" required>
            <el-upload :before-upload="beforeAvatarUpload" action="" multiple :http-request="uploadFile" :show-file-list="true" :file-list="fileList" style="display: inline-block; margin: 0 10px" :on-remove="handleRemove">
              <el-button size="small" type="success" icon="el-icon-upload">读取压缩包</el-button>
            </el-upload>

          </el-form-item>
        </el-row>
        <el-row style="margin-bottom:50px">
          <el-table :data="tableData1" style="width: 100%" v-if="isshouw1">
            <el-table-column prop="input_name" label="Input">

            </el-table-column>
            <el-table-column prop="output_name" label="Output">

            </el-table-column>
            <el-table-column prop="score" label="Score">
              <template slot-scope="scope">

                <span v-if="isrule_type === 2">
                  <el-input v-model="scope.row.score" @input="$forceUpdate()" type="text"></el-input>
                </span>
                <span v-else>{{ scope.row.score }}</span>

              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-button @click="saveGame('problem')">保存题目</el-button>

      </el-form>

    </div>
  </div>
</template>
    
<script>
import CodeMirror from "@/components/CodeMirror";
import uploadFileBlob from "@/config/uploadFileBlobForOjTestcase";
import md5 from 'js-md5';
import uploadFile1 from "@/config/uploadFileSchool";



// import uploadFile from "@/config/uploadFileAll";
const JSZip = require("jszip")
const uuid = require('uuid')

import {
  tchAddOrUpdateOjProblem,
  getOjProblemSourceList,
  getOjProblemDifficultyList,
  getOjProblemTagGroupList,
  tchAddProblemForContest,
  getOjProblemInfoById,
  compileSpj
}
  from "@/api/educational.js";
import markdownShow from "@/components/markdownShow";


export default {
  components: {
    CodeMirror,
    markdownShow: markdownShow,

  },
  data() {
    return {
      isShowMarkDown: false,
      isShowRichtext: false,
      showmarkdown: true,
      showmarkdown1: true,
      showmarkdown2: true,
      showmarkdown3: true,
      value1: '2',
      problem_testcase_id: "",

      isShow3: false,
      isReloadData: true,

      spj_code1: '',
      spjVersion: '',
      outList: [],

      outNum: [],
      problem_id: '',
      isshowTable: true,
      isrule_type: 1,
      isShow1: false,
      isShow2: true,

      contest_id: '',
      difficultyId: '',
      spj: '0',
      num: null,
      uploadParams: [],
      fileList: [],


      isShow: false,
      tableData: [],
      isshouw1: true,
      tableData1: [

      ],

      form1: {

      },
      loadingCompile: false,
      rules: {
        // code: { required: true, message: '请输入试题编号', trigger: 'blur' },
        total_score: { required: true, message: '请输入分值', trigger: 'blur' },
        title: { required: true, message: '请输入题目名称', trigger: 'blur' },
        description: { required: true, message: '请输入描述', trigger: 'blur' },
        input_description: { required: true, message: '请输入输入数据', trigger: 'blur' },
        output_description: { required: true, message: '请输入输出数据', trigger: 'blur' },

      },
      //添加标签
      inputVisible: false,
      inputValue: '',
      spjMode: '',

      problem: {
        fileList1: [],
        attachment_url: '',
        spj_language: 0,
        markdown_explain: '',
        md_input_description: '',
        md_output_description: '',
        md_hint: '',
        samples: [{ input: "", output: "" }],
        code: '',
        tagIdArr: [],
        sort_num: 1,
        share_submission: '0',
        is_public: '0',
        io_mode: 2,
        rule_type: 1,
        test_case_score: [],
        test_case_id: uuid.v1(),
        total_score: 100,
        spj1: false,
        dynamicTags: [],
        visible: '1',
        languages: ['0', '1', '2'],

        codeTemplates: [],


      },
      allLanguage: [
        {
          name: 'c',
          id: 0,
        },
        {
          name: 'c++',
          id: 1,
        },
      ],
      //问题来源
      problemList: [

      ],
      difficultyList: [],
      //算法标签列表
      tagIdArrList: [

      ],
      //可选编程语言
      languagess: [
        {
          id: '0',
          name: 'C'
        },
        {
          id: '1',
          name: 'C++'
        },
        {
          id: '2',
          name: 'Python3'
        }
      ],
      codeTemplate: [
        {
          checked: false,
          id: '0',
          name: 'C',
          content_type: "text/x-c++src",
          config: {
            template: "",

          }
        },
        {
          checked: false,
          id: '1',
          name: 'C++',
          content_type: "text/x-c++src",
          config: {
            template: "",

          }
        },
        {
          checked: false,
          id: '2',
          name: 'Python3',
          content_type: "text/x-c++src",
          config: {
            template: "",

          }
        }
      ]
    }
  },
  watch: {

    // 'problem.total_score'(val) {
    //   console.log(val, 123456);
    //   if (val == '') {
    //     this.problem.total_score = 0
    //   }
    // },
    'problem.rule_type'(val) {
      this.isrule_type = 1

      this.isrule_type = val

      console.log(this.isrule_type)
    },
    'problem.spj_code'(val) {
      if (this.$route.query != null) {
        if (this.spj_code1 === val) {
          this.spjVersion = this.problem.spj_version
          console.log(this.spjVersion)
        } else {
          this.spjVersion = ''
          console.log(this.spjVersion)
        }
      }
    },
    numTotal1: {
      handler: function () {
        var that = this;
        if (that.isrule_type === 1) {

          console.log(that.numTotal1, 111)
          let numTotal = 0
          that.isshouw1 = false

          that.tableData1.map((item) => {
            item.score = that.numTotal1
            numTotal += item.score
          })
          that.$nextTick(() => {
            that.isshouw1 = true
          })
          if (this.problem.total_score - numTotal < 0) {
            var end = this.tableData1[this.tableData1.length - 1];
            let end1 = parseInt(end.score) + (this.problem.total_score - numTotal);
            end.score = end1;
          } else if (this.problem.total_score - numTotal > 0) {
            var end2 = this.tableData1[this.tableData1.length - 1];
            let end3 = parseInt(end2.score) + (this.problem.total_score - numTotal);
            end2.score = end3;
          }
        }
      }

    },
    numTotal: {
      handler: function () {
        var that = this;
        that.isshouw1 = false
        if (that.isrule_type === 2) {
          that.problem.total_score = that.numTotal;

        }
        that.$nextTick(() => {
          that.isshouw1 = true
        })
      }


    },

  },
  created() {

    this.contest_id = this.$route.query.contest_id
    if (this.$route.query.type === 'Game') {
      this.isShow1 = true
      this.isShow2 = false
      this.isShow3 = true

    } else {
      this.isShow1 = false
      this.isShow2 = true
      this.isShow3 = false


    }


  },
  computed: {
    numTotal() {
      return this.tableData1
        .map((row) => row.score)
        .reduce((acc, cur) => parseFloat(cur) + acc, 0);
    },
    numTotal1() {
      return parseInt(parseInt(this.problem.total_score) / parseInt(this.tableData1.length))
    },
  },
  mounted() {

    this.isShowMarkDown = true
    this.isShowRichtext = false
    this.showmarkdown = false
    this.showmarkdown1 = false
    this.showmarkdown2 = false
    this.showmarkdown3 = false
    this.$nextTick(() => {
      this.showmarkdown3 = true
      this.$nextTick(() => {
        this.showmarkdown2 = true
        this.$nextTick(() => {
          this.showmarkdown1 = true
          this.$nextTick(() => {
            this.showmarkdown = true
          })
        })
      })
    })

    // this.value1 = sessionStorage.getItem('isMarkDown1')
    // console.log(this.value1, 121212);
    // if (this.$route.query.typecontent === 'add') {
    //   this.value1 = sessionStorage.getItem('isMarkDown1')
    //   if (this.value1 === '1') {
    //     this.isShowRichtext = true
    //     this.isShowMarkDown = false
    //   } else if (this.value1 === '2') {
    //     this.isShowMarkDown = true
    //     this.isShowRichtext = false

    //   }
    //   console.log(this.value1, 456323);
    // }



    if (this.$route.query.edit === '1') {
      this.problem_id = this.$route.query.problem
      this.getOjProblemInfoById()

    }
    if (this.$route.query.edit === '2') {
      this.problem_id = this.$route.query.problem
      this.getOjProblemInfoById1()

    }

    // this.adminGetOjProblemTagList()
    this.getOjProblemTagGroupList()
    this.getOjProblemDifficultyList()
    this.getOjProblemSourceList()
    this.info()
  },
  methods: {
    uploadFile1() { },

    //上传
    handleRemove1(file, fileList) {
      console.log(file, fileList);
      this.problem.fileList1 = []
      this.problem.attachment_url = ''
    },
    async handleChangeFile1(file, fileList) {
      console.log("上传课程体系缩略图");
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status);
      }
    },

    async uploadFileOss(list) {
      this.uploadFileTime = true;
      await uploadFile1(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log("res");
          console.log(res, 2323232);
          this.problem.fileList1 = res
          this.problem.fileList1.map((item) => {
            this.problem.attachment_url = item.url
          })
          this.uploadFileTime = false;
        }
      );
    },
    changeMardown1(val) {
      this.problem.md_input_description = val

    },
    changeMardown2(val) {
      this.problem.md_output_description = val

    },
    changeMardown3(val) {
      this.problem.md_hint = val

    },
    changeMardown(val) {
      this.problem.markdown_explain = val

    },
    SaveMarkDown1(md, html) {
      console.log("保存markdown");
      console.log(md, 45412);
      console.log(html, 13223);
      this.problem.md_input_description = md;
    },
    SaveMarkDown2(md, html) {
      console.log("保存markdown");
      console.log(md, 45412);
      console.log(html, 13223);
      this.problem.md_output_description = md;
    },
    SaveMarkDown3(md, html) {
      console.log("保存markdown");
      console.log(md, 45412);
      console.log(html, 13223);
      this.problem.md_hint = md;
    },
    SaveMarkDown(md, html) {
      console.log("保存markdown");
      console.log(md, 45412);
      console.log(html, 13223);

      this.problem.markdown_explain = md;
      // this.ruleForm.html_explain = html;
    },
    reloadPart() {
      this.isReloadData = false
      this.$nextTick(() => {
        this.isReloadData = true

      })
    },
    compileSpj() {
      compileSpj({
        spjCode: this.problem.spj_code,
        spjLanguage: this.problem.spj_language
      }).then((res) => {
        console.log(res, 123456)
        if (res.error === null) {
          this.spjVersion = res.spjVersion
          console.log(this.spjVersion)
          this.$message.success("编译成功");

        } else {
          this.$message.warning('编译失败')

        }


      })

    },
    getOjProblemInfoById1() {
      getOjProblemInfoById({
        problem_id: this.contest_id
      }).then((res) => {
        console.log(res, 111)


        this.spj_code1 = res.ojProblemInfo.spj_code
        sessionStorage.setItem('isMarkDown1', res.ojProblemInfo.description_show_type)
        // this.value1 = sessionStorage.getItem('isMarkDown1')
        this.value1 = res.ojProblemInfo.description_show_type.toString()
        console.log(this.value1, 63233);
        if (this.value1 === '1') {
          this.isShowRichtext = true
          this.isShowMarkDown = false
        } else if (this.value1 === '2') {
          this.isShowMarkDown = true
          this.isShowRichtext = false

        }

        this.problem = res.ojProblemInfo
        this.problem_testcase_id = res.ojProblemInfo.test_case_id;
        this.showmarkdown = false
        this.showmarkdown1 = false
        this.showmarkdown2 = false
        this.showmarkdown3 = false
        // if (res.ojProblemInfo.attachment_url != '') {
        //   this.problem.fileList1 = []
        //   this.problem.fileList1.push({
        //     url: res.ojProblemInfo.attachment_url,
        //     name: res.ojProblemInfo.attachment_url.split('/').slice(-1)[0].split('-').slice(-1)[0],

        //   })
        // }
        if (res.ojProblemInfo.attachment_url === null || res.ojProblemInfo.attachment_url === "") {
          this.problem.fileList1 = []

        } else {
          console.log(res.ojProblemInfo.attachment_url.split('/').slice(-1)[0].split('-').slice(-1)[0], 412121212);
          this.problem.fileList1 = []
          this.problem.fileList1.push({
            name: res.ojProblemInfo.attachment_url.split('/').slice(-1)[0].split('-').slice(-1)[0],
            url: res.ojProblemInfo.attachment_url
          })
        }

        this.$nextTick(() => {
          if (res.ojProblemInfo.md_hint != null) {
            this.problem.md_hint = res.ojProblemInfo.md_hint
          } else {
            this.problem.md_hint = ''
          }
          this.showmarkdown3 = true
          this.$nextTick(() => {
            if (res.ojProblemInfo.md_output_description != null) {
              this.problem.md_output_description = res.ojProblemInfo.md_output_description
            } else {
              this.problem.md_output_description = ''

            }
            this.showmarkdown2 = true
            this.$nextTick(() => {
              if (res.ojProblemInfo.md_input_description != null) {
                this.problem.md_input_description = res.ojProblemInfo.md_input_description

              } else {
                this.problem.md_input_description = ''
              }
              this.showmarkdown1 = true
              this.$nextTick(() => {
                if (res.ojProblemInfo.md_description != null) {
                  this.problem.markdown_explain = res.ojProblemInfo.md_description
                } else {
                  this.problem.markdown_explain = ''
                }
                this.showmarkdown = true
              })

            })
          })

        })


        this.problem.languages = JSON.parse(res.ojProblemInfo.languages)
        // this.problem.tagIdArr = res.ojProblemInfo.problemTagArr
        let arr = []
        res.ojProblemInfo.problemTagArr.map((item) => {
          arr.push(item.oj_problem_tag_id)
          console.log(arr, 112)

        })
        this.problem.tagIdArr = arr

        if (res.ojProblemInfo.share_submission === true) {
          this.problem.share_submission = '1'
        } else {
          this.problem.share_submission = '0'
        }
        if (res.ojProblemInfo.is_public === true) {
          this.problem.is_public = '1'
        } else {
          this.problem.is_public = '0'
        }
        this.tableData1 = JSON.parse(res.ojProblemInfo.test_case_score)

        this.problem.samples = JSON.parse(res.ojProblemInfo.samples)
        // this.codeTemplate = JSON.parse(res.ojProblemInfo.template)
        console.log(res.ojProblemInfo.template, 221)

        if (res.ojProblemInfo.spj === true) {
          this.spj = '1'
        } else {
          this.spj = '0'
        }
        this.isShow = res.ojProblemInfo.spj

        this.problem.spj_language = JSON.parse(res.ojProblemInfo.spj_language)
        this.difficultyId = res.ojProblemInfo.id
        // this.codeTemplate = JSON.parse(res.ojProblemInfo.template)
        // console.log(this.codeTemplate, 221)

        // if (res.ojProblemInfo.spj === true) {
        //   this.spj = '1'
        // } else {
        //   this.spj = '0'
        // }
        // this.problem.spj_language = JSON.parse(res.ojProblemInfo.spj_language)
        // this.difficultyId = res.ojProblemInfo.id
        this.reloadPart()

      })
    },
    getOjProblemInfoById() {
      getOjProblemInfoById({
        problem_id: this.problem_id
      }).then((res) => {
        console.log(res, 111)
        this.spj_code1 = res.ojProblemInfo.spj_code
        sessionStorage.setItem('isMarkDown1', res.ojProblemInfo.description_show_type)
        // this.value1 = sessionStorage.getItem('isMarkDown1')
        this.value1 = res.ojProblemInfo.description_show_type.toString()
        console.log(this.value1, 63233);
        if (this.value1 === '1') {
          this.isShowRichtext = true
          this.isShowMarkDown = false
        } else if (this.value1 === '2') {
          this.isShowMarkDown = true
          this.isShowRichtext = false

        }
        this.problem = res.ojProblemInfo
        this.difficultyId = this.problem.id
        this.problem_testcase_id = res.ojProblemInfo.test_case_id;
        this.showmarkdown = false
        this.showmarkdown1 = false
        this.showmarkdown2 = false
        this.showmarkdown3 = false
        // if (res.ojProblemInfo.attachment_url != '') {
        //   this.problem.fileList1 = []
        //   this.problem.fileList1.push({
        //     url: res.ojProblemInfo.attachment_url,
        //     name: res.ojProblemInfo.attachment_url.split('/').slice(-1)[0].split('-').slice(-1)[0],

        //   })
        // }
        if (res.ojProblemInfo.attachment_url === null || res.ojProblemInfo.attachment_url === "") {
          this.problem.fileList1 = []

        } else {
          console.log(res.ojProblemInfo.attachment_url.split('/').slice(-1)[0].split('-').slice(-1)[0], 412121212);
          this.problem.fileList1 = []
          this.problem.fileList1.push({
            name: res.ojProblemInfo.attachment_url.split('/').slice(-1)[0].split('-').slice(-1)[0],
            url: res.ojProblemInfo.attachment_url
          })
        }



        this.$nextTick(() => {
          if (res.ojProblemInfo.md_hint != null) {
            this.problem.md_hint = res.ojProblemInfo.md_hint
          } else {
            this.problem.md_hint = ''
          }
          this.showmarkdown3 = true
          this.$nextTick(() => {
            if (res.ojProblemInfo.md_output_description != null) {
              this.problem.md_output_description = res.ojProblemInfo.md_output_description
            } else {
              this.problem.md_output_description = ''

            }
            this.showmarkdown2 = true
            this.$nextTick(() => {
              if (res.ojProblemInfo.md_input_description != null) {
                this.problem.md_input_description = res.ojProblemInfo.md_input_description

              } else {
                this.problem.md_input_description = ''
              }
              this.showmarkdown1 = true
              this.$nextTick(() => {
                if (res.ojProblemInfo.md_description != null) {
                  this.problem.markdown_explain = res.ojProblemInfo.md_description
                } else {
                  this.problem.markdown_explain = ''
                }
                this.showmarkdown = true
              })

            })
          })

        })

        // this.showmarkdown = false
        // this.$nextTick(() => {
        //   if (res.ojProblemInfo.md_description != null) {
        //     this.problem.markdown_explain = res.ojProblemInfo.md_description

        //   } else {
        //     this.problem.markdown_explain = ''

        //   }
        //   this.showmarkdown = true
        // })



        this.problem.languages = JSON.parse(res.ojProblemInfo.languages)
        // this.problem.tagIdArr = res.ojProblemInfo.problemTagArr
        console.log(res.ojProblemInfo.problemTagArr, 11)
        let arr = []
        res.ojProblemInfo.problemTagArr.map((item) => {
          arr.push(item.oj_problem_tag_id)
          console.log(arr, 112)

        })
        this.problem.tagIdArr = arr


        if (res.ojProblemInfo.share_submission === true) {
          this.problem.share_submission = '1'
        } else {
          this.problem.share_submission = '0'
        }
        if (res.ojProblemInfo.is_public === true) {
          this.problem.is_public = '1'
        } else {
          this.problem.is_public = '0'
        }
        this.tableData1 = JSON.parse(res.ojProblemInfo.test_case_score)

        this.problem.samples = JSON.parse(res.ojProblemInfo.samples)
        // this.codeTemplate = JSON.parse(res.ojProblemInfo.template)
        console.log(res.ojProblemInfo.template, 221)

        if (res.ojProblemInfo.spj === true) {
          this.spj = '1'
        } else {
          this.spj = '0'
        }
        this.isShow = res.ojProblemInfo.spj

        this.problem.spj_language = JSON.parse(res.ojProblemInfo.spj_language)
        this.reloadPart()


      })
    },
    //算法标签
    getOjProblemTagGroupList() {
      getOjProblemTagGroupList({}).then((res) => {
        console.log(res, 115)
        this.tagIdArrList = res.ojProblemTagGroupList
      })
    },
    //获取难度标签
    getOjProblemDifficultyList() {
      getOjProblemDifficultyList({

      }).then((res) => {
        console.log(res, 22)

        this.difficultyList = res.ojProblemDifficultyList
      })
    },
    info() {

      this.isrule_type = 1
    },
    saveGame(formName) {
      if (this.tableData1.length === 0) {
        this.$message.warning('测试用例不能为空')
        return false
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.difficultyId) {
              console.log(123, 45)
              tchAddOrUpdateOjProblem({
                id: this.difficultyId,
                attachment_url: this.problem.attachment_url,
                spj_version: this.spjVersion,
                description_show_type: this.value1,
                md_description: this.problem.markdown_explain,
                md_input_description: this.problem.md_input_description,
                md_output_description: this.problem.md_output_description,
                md_hint: this.problem.md_hint,

                // test_case_score: JSON.stringify(this.problem.test_case_score),
                test_case_score: JSON.stringify(this.tableData1),


                // test_case_id: uuid.v1(),
                test_case_id: this.problem_testcase_id,

                total_score: this.problem.total_score,
                spj: this.spj,
                visible: this.problem.visible,
                languages: JSON.stringify(this.problem.languages),
                samples: JSON.stringify(this.problem.samples),
                description: this.problem.description,
                input_description: this.problem.input_description,
                output_description: this.problem.output_description,
                hint: this.problem.hint,
                sort_num: this.problem.sort_num,
                // code: this.problem.code,
                title: this.problem.title,
                time_limit: this.problem.time_limit,
                memory_limit: this.problem.memory_limit,
                oj_problem_difficulty_id: this.problem.oj_problem_difficulty_id,
                difficulty: this.problem.difficulty,
                oj_problem_source_id: this.problem.oj_problem_source_id,
                tagIdArr: JSON.stringify(this.problem.tagIdArr),
                rule_type: this.problem.rule_type,
                io_mode: this.problem.io_mode,
                share_submission: this.problem.share_submission,
                is_public: this.problem.is_public,

                spj_code: this.problem.spj_code,
                spj_language: this.problem.spj_language,
                contest_id: this.contest_id

                // spj: this.problem.spj1,
                // template: JSON.stringify(this.codeTemplate),
              }).then((res) => {
                console.log(res, 33321)
                this.goback()

              })
            } else {
              tchAddOrUpdateOjProblem({
                id: '',
                spj_version: this.spjVersion,
                attachment_url: this.problem.attachment_url,
                description_show_type: this.value1,
                md_description: this.problem.markdown_explain,
                md_input_description: this.problem.md_input_description,
                md_output_description: this.problem.md_output_description,
                md_hint: this.problem.md_hint,
                test_case_score: JSON.stringify(this.problem.test_case_score),
                test_case_id: this.problem_testcase_id,
                total_score: this.problem.total_score,
                spj: this.spj,
                visible: this.problem.visible,
                languages: JSON.stringify(this.problem.languages),
                samples: JSON.stringify(this.problem.samples),
                description: this.problem.description,
                input_description: this.problem.input_description,
                output_description: this.problem.output_description,
                hint: this.problem.hint,
                sort_num: this.problem.sort_num,
                title: this.problem.title,
                time_limit: this.problem.time_limit,
                memory_limit: this.problem.memory_limit,
                oj_problem_difficulty_id: this.problem.oj_problem_difficulty_id,
                difficulty: this.problem.difficulty,
                oj_problem_source_id: this.problem.oj_problem_source_id,
                tagIdArr: JSON.stringify(this.problem.tagIdArr),
                rule_type: this.problem.rule_type,
                io_mode: this.problem.io_mode,
                share_submission: this.problem.share_submission,
                is_public: this.problem.is_public,
                spj_code: this.problem.spj_code,
                spj_language: this.problem.spj_language,
                contest_id: this.contest_id
              }).then((res) => {
                console.log(res, 33321)
                // 添加比赛题目·
                tchAddProblemForContest({
                  contest_id: this.contest_id,
                  problemIds: JSON.stringify([res.ojProblemId]),

                }).then(() => {
                  this.$message.success("填加成功！！")
                  this.goback()
                })

              })
            }
          }
        });
      }

    },

    //获取来源标签
    getOjProblemSourceList() {
      getOjProblemSourceList({
        page_no: 1,
        page_size: 100
      }).then((res) => {
        console.log(res, 45)
        this.problemList = res.ojProblemSourceList
      })
    },
    //获取算法标签
    // adminGetOjProblemTagList() {
    //   adminGetOjProblemTagList({
    //     page_no: 1,
    //     page_size: 100
    //   }).then((res) => {
    //     console.log(res, 7787)
    //     // tableData3
    //     this.tagIdArrList = res.ojProblemTagList

    //   })
    // },
    arrayBufferToBase64(buffer) {
      let binary = "";
      const bytes = new Uint8Array(buffer);
      const len = bytes.byteLength;
      for (let i = 0; i < len; i += 1) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary); //base64
    },

    // 验证文件格式是否正确
    beforeAvatarUpload(file) {
      let isFile = file.name.split('.')[file.name.split('.').length - 1] == 'zip'
      if (!isFile) {
        this.$message.error('导入文件格式不正确')
        return isFile

      }

      const isLt30M = file.size / 1024 / 1024 < 5
      if (!isLt30M) {
        this.$message.error('上传的文件大小不能超过 5MB!')
        return isLt30M

      }
    },
    async uploadFile(file) {
      await uploadFileBlob('', '', '', true);
      console.log('重新上传测试用例,更新ID')
      this.problem_testcase_id = uuid.v1();

      var problem_info = {}; //测试用例数组
      var problem_case; //单测试点
      var test_cases = {};
      var problem_case_arr = []// 测试点组合
      var problem_in_num = 0;
      var problem_out_num = 0;
      var spj = this.spj === '0' ? false : true;

      var that = this;
      //上传压缩包的输入输出文件
      JSZip.loadAsync(file.file).then(async function (zip) {
        zip.forEach(function (relativePath, zipEntry) {
          //忽略MAC路径
          if (zipEntry.name.indexOf("__MACOSX/._") > -1) {
            console.log('检测到mac路径')
            return;
          }
          //寻找输入点
          if (zipEntry.name.split('.')[1] === 'in') {

            problem_in_num++; //记录输入点数量
            //寻找输入点对应的输出点
            zip.forEach(function (relativePath_1, zipEntry_1) {

              if (zipEntry_1.name.split('.')[1] === 'out') {
                if (zipEntry_1.name.split('.')[0] === zipEntry.name.split('.')[0]) {
                  //读取对应输出点内容
                  zipEntry_1.async('string').then((res) => {
                    problem_out_num++; //记录输入点数量
                    problem_case = {};//单测试点数据
                    problem_case.input_name = zipEntry.name;
                    problem_case.output_name = zipEntry.name.split('.')[0] + '.out';


                    var lines = res.split('\n');

                    for (let i = 0; i < lines.length; i++) {
                      lines[i] = lines[i].trimEnd();
                    }

                    problem_case.stripped_output_md5 = md5(lines.join('\n').trimEnd());
                    problem_case_arr.push(problem_case); //测试点组合

                    //等待文件扫描完成
                    if (problem_out_num === problem_in_num) {

                      for (let i = 0; i < problem_case_arr.length; i++) {
                        test_cases[i + 1] = problem_case_arr[i];

                        that.tableData1 = problem_case_arr;
                        that.problem.test_case_score = problem_case_arr;
                        that.tableData1[i].score = that.num;

                      }
                      //组合测试点info
                      problem_info.spj = spj;
                      problem_info.test_cases = test_cases;

                      //上传problem_info 文件
                      var jsonStr = JSON.stringify(problem_info);
                      uploadFileBlob(
                        Buffer.from(jsonStr),
                        "problem/" + that.problem_testcase_id + "/" + 'info',
                        function (res) {
                          console.log(res, "上传info文件");
                        }
                      );
                    }
                  })
                }
              }
            })
          }

          //上传测试用例文件
          zipEntry.async("base64").then(function (res) {
            uploadFileBlob(
              Buffer.from(res, "base64"),
              "problem/" + that.problem_testcase_id + "/" + zipEntry.name,
              function () {
                // console.log(res, '上传测试用例文件');
              }
            );
          });
        });
      })
    },




    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.tableData1 = []
    },
    // handleExceed() {
    //   this.$message.warning("请删除原有文件,再重新上传");
    // },
    goback() {
      this.$router.go(-1);
    },
    spjBtn(val) {
      console.log(val, 456)
      if (val === true) {
        this.spj = '1'
      } else {
        this.spj = '0'
      }
      this.isShow = val



    },
    addSample() {
      this.problem.samples.push({ input: '', output: '' })
    },
    deleteSample(index) {
      this.problem.samples.splice(index, 1)
    },
    //选择语言
    languagesChange(val) {
      console.log(val)
    },
    //选择标签
    handleClose(tag) {
      this.problem.dynamicTags.splice(this.problem.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.problem.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    }
  }

}
</script>
    
<style lang="scss" scoped>
.subject {
  height: 100%;
  width: 100%;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.table {
  margin: 10px;
  background: 10px;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

.add-samples {
  width: 100%;
  background-color: #fff;
  border: 1px dashed #aaa;
  outline: none;
  cursor: pointer;
  color: #666;
  height: 35px;
  font-size: 14px;

  &:hover {
    background-color: #f9fafc;
  }

  i {
    margin-right: 10px;
  }
}

.add-sample-btn {
  margin-bottom: 10px;
}

/deep/ .mce-statusbar > .mce-container-body {
  display: none;
}
</style>